import React from 'react';

import styles from './XKanbanTicket.module.scss';
import {} from "../../Utilities/Utilities";
import { XRow } from '../layouts/XRow';
import { XColumn } from '../layouts/XColumn';
import { EKanbanTicketType, ETheme } from '../../types/enums';
import { IComponentProps, IComponentState, XComponent } from '../commons';


export interface IKanbanTicketProps extends IComponentProps {
    children? : React.ReactNode;
    header? : string | undefined;
    theme?: ETheme;
    type: EKanbanTicketType;
}

export interface IKanbanTicketState extends IComponentState {
    theme: ETheme;
}

export class XKanbanTicket extends XComponent<HTMLDivElement, IKanbanTicketProps, IKanbanTicketState> {
    public render(): React.ReactNode {
        return <div className={styles.XKanbanTicket} data-ticket-type={this.props.type}>
            <XRow>
                <XColumn width={'50px'}>

                </XColumn>
                <XColumn>

                </XColumn>
            </XRow>
        </div>;
    }
}

